import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import { Spring } from 'react-spring';

import { HashLink as Link } from 'react-router-hash-link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchInput from 'components/SearchModal/SearchInput';

import {
  NotificationSlider,
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
  SweetAlert,
} from 'C4';

import { storageKeys, bgVideo } from 'settings';
import logo from 'assets/images/logo/logo_white.png';

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '1993-01-10',
      appId: -1,
      userStatus: 'startTraining',
      popup: false,
    };

    this.close = this.close.bind(this);
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res && res.missed_items && res.missed_items[0]) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res && res.response) {
        if (res.response.training_graduated) {
          return this.setState({ userStatus: 'graduated' });
        }
        if (res.response.training_started) {
          return this.setState({ userStatus: 'continueTraining' });
        }
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    DataHandler.matchAppId().then((appId) => {
      StorageHandler.load(storageKeys.user).then((user) => {
        this.setState({ appId });
        if (user && user.response.sales_companion_registered === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;

          APIHandler.updateUser(appId, obj.response.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.response.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        }
      });
    });
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(APIHandler.getUnreadMessages, this.state.lastCheckedMessages).then(
      (res) => {
        if (res && res.missed_items && res.missed_items[0]) {
          this.setState({ unreadMessageCount: res.missed_items[0].count });
        }
      },
    );
  }

  close() {
    this.setState({
      popup: false,
    });
  }

  render() {
    const { unreadMessageCount, userStatus, popup, appId } = this.state;

    const open = () => {
      this.setState({
        popup: true,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo />}
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                {/* <img src={`/${Logo}`} className="homeLogo" alt="logo" /> */}

                <div className="homeLogo">
                  <img src={logo} className="logo" alt={name} />
                </div>

                {/* <h1>{i18n.translate('homeScreen.title')}</h1> */}
                <div className="homeView__title--action">
                  <SearchInput />
                  <div className="subBtns">
                    {/* <Link to="/main/messages" className="messageBtn clear">
                      {unreadMessageCount === 0 && (
                        <p>
                          <FontAwesomeIcon icon={['fas', 'envelope']} />
                          {i18n.translate('nav.messages')}
                        </p>
                      )}
                      {unreadMessageCount > 0 && (
                        <p>
                          <FontAwesomeIcon icon={['fas', 'envelope']} />
                          {i18n.translate(
                            `${
                              unreadMessageCount === 1 ? 'general.message' : 'general.messagePlural'
                            }`,
                            { count: unreadMessageCount },
                          )}
                        </p>
                      )}
                    </Link> */}
                    {userStatus !== 'graduated' && (
                      <a
                        key="rewards"
                        onClick={() => {
                          open();
                        }}
                        className="messageBtn disabled"
                      >
                        <p>
                          <FontAwesomeIcon icon={['fas', 'lock']} />
                          {i18n.translate('nav.rewards')}
                        </p>
                      </a>
                    )}
                    {userStatus === 'graduated' && (
                      <Link to="/main/rewards" className="messageBtn">
                        <p>
                          <FontAwesomeIcon icon={['fas', 'trophy']} />
                          {i18n.translate('nav.rewards')}
                        </p>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Spring>
        <div className="buttonWrapper">
          Download now:
          <StoreButtons />
        </div>
        <SweetAlert
          title=""
          trigger={popup}
          {...{
            title: '',
            html: 'Become a BVI Specialist by completing your training under the Train tab, to be eligible for exclusive BVI Rewards. ',
            confirmButtonText: i18n.translate('general.close'),
            onClose: this.close,
          }}
        />
        <NotificationSlider appId={appId} middle right />
        <div className="border-bottom" />
      </div>
    );
  }
}
